import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const PAIN_POINTS = [{
  icon: '😔',
  text: 'Sentís que tu energía está bloqueada y no sabés cómo liberarla'
}, {
  icon: '💸',
  text: 'Los cursos presenciales de Reiki son carísimos y difíciles de coordinar'
}, {
  icon: '😰',
  text: 'Querés ayudar a otros pero no tenés las herramientas ni la certificación'
}, {
  icon: '🌀',
  text: 'Probaste meditación y otras técnicas pero sentís que te falta algo más profundo'
}, {
  icon: '⏰',
  text: 'No tenés tiempo para asistir a clases presenciales con horarios fijos'
}, {
  icon: '❓',
  text: 'Te interesa el Reiki pero no sabés por dónde empezar ni en quién confiar'
}];
export function ProblemSection() {
  return <section className="py-20 px-4 bg-white relative overflow-hidden" data-id="element-178">
      <div className="max-w-6xl mx-auto" data-id="element-179">
        <div className="text-center mb-16" data-id="element-180">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6" data-id="element-181">
            ¿Te Sentís Identificado/a?
          </motion.h2>
          <div className="w-24 h-1 bg-violet-500 mx-auto rounded-full" data-id="element-182" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-183">
          {PAIN_POINTS.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-violet-500 hover:shadow-xl transition-shadow duration-300" data-id="element-184">
              <div className="text-4xl mb-4" data-id="element-185">{point.icon}</div>
              <p className="text-gray-700 text-lg leading-relaxed font-medium" data-id="element-186">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto" data-id="element-187">
          <p className="text-xl md:text-2xl text-gray-800 font-medium mb-8" data-id="element-188">
            Si respondiste <span className="text-violet-600 font-bold" data-id="element-189">SÍ</span>{' '}
            a alguna de estas preguntas... este MegaPack fue creado
            especialmente para vos.
          </p>
          <CTAButton text="¡QUIERO LA SOLUCIÓN!" data-id="element-190" />
        </motion.div>
      </div>
    </section>;
}